/* eslint-disable no-multi-spaces */
/* eslint-disable comma-spacing */
/* eslint-disable react/no-multi-comp */
/* eslint-disable react-hooks/exhaustive-deps */
import 'react-datepicker/dist/react-datepicker.css';
import React, { useState, useEffect, useReducer } from 'react';
import { Form, Button, DatePicker, FormControl, Alert } from 'rsuite';
import { isFunction } from 'lodash';
import { dateFns } from '../components/DateFnsUtils';
import { Table } from '../components/table/Table';
import FilterQueryParams from '../components/FilterQueryParams';
import singsStatuses from '../components/statuses';
import validator from '../helpers/validator';
import SignUpdateDialog from '../components/dialog/DialogLoanUpdate.js';
import Tabs from '../components/Tabs.js';
import { ButtonIcon, ColumnStatus } from '../components';
import Signs from '../services/signs';
import REQUEST_TYPES from '../constants/signs/requestTypes';
import VisibilityIcon from '@material-ui/icons/Visibility';
import DialogForm from '../components/dialog/DialogForm';
import cuotitasStore from '../services/cuotitasStore.js';
import ShortUniqueId from 'short-unique-id';

const sortedKeyMap = { created_at_time: 'created_at', order: 'desc' };
const defaultSorted = [{ dataField: 'created_at', order: 'desc' }];
const baseQuery = { filters: null, sortOrder: 'desc', sortField: 'created_at', pageNumber: 1, pageSize: 10 };

function ColumnStatusFormatter (cellContent, row) {
    return (
        <ColumnStatus type={cellContent.type} text={cellContent.text} />
    );
}

function ColumnActionsFormatter (cellContent, row, rowIndex, { signUpdateDialogOpen }) {
    return (
        <div>
            <ButtonIcon title='Ver Contrato' size='small' icon={(<VisibilityIcon className='svg-icon' />)} onClick={() => signUpdateDialogOpen(row.id)} />
        </div>
    );
}

export default function Loans () {
    const tabs = [
        { id: 1, name: 'pending', label: 'Pendientes' },
        { id: 2, name: 'success', label: 'Exitosos' },
        { id: 3, name: 'fails', label: 'Rechazados' },
        { id: 4, name: 'deleted', label: 'Anulados' },
    ];

    const columns = [
        { text: 'ID'      , dataField: 'id' },
        { text: 'Cliente' , dataField: 'name'       , sort: false, align: 'left' },
        { text: 'DNI'     , dataField: 'dni'        , sort: false, align: 'left', headerAlign: 'left' },
        { text: 'Fecha'   , dataField: 'created_at' , sort: false },
        { text: 'Estado'  , dataField: 'status'     , sort: false, align: 'left', headerAlign: 'left', formatter: ColumnStatusFormatter },
        { text: ' '       , dataField: 'idPerson'   , sort: false, align: 'center', formatExtraData: { signUpdateDialogOpen }, formatter: ColumnActionsFormatter }
    ];

    const [loading, setLoading] = useState(false);

    // filters

    const [tab, setTab] = useState(tabs[0]);
    const [search, setSearch] = useState('');
    const [date, setDate] = useState(null);

    const [query, setQuery] = useReducer((oldQuery, newQuery) => {
        if (isFunction(newQuery)) {
            return newQuery(oldQuery);
        }
        return newQuery;
    }, baseQuery);

    // data

    const [signList, setSignList] = useState([]);
    const [signSelected, setSignSelected] = useState();

    // sign update dialog

    const [signUpdateDialogShow, setSignUpdateDialogShow] = useState(false);

    function signUpdateDialogOpen (id) {
        setSignSelected(id);
        setSignUpdateDialogShow(true);
    };

    function signUpdateDialogClose () {
        setSignSelected(0);
        setSignUpdateDialogShow(false);
        filter();
    }

    // sign create dialog

    const [signCreateDialogShow, setSignCreateDialog] = useState(false);

    function signCreateDialogOpen () {
        setSignCreateDialog(true);
    }

    function signCreateDialogClose () {
        setSignCreateDialog(false);
        filter();
    }

    // actions

    async function filter () {
        try {
            setLoading(true);

            const filters = new FilterQueryParams();

            const { sortField, sortOrder } = query;

            const options = {
                order: `${sortedKeyMap[sortField] || sortField}-${sortOrder.toUpperCase()}`,
                pageSize: query.pageSize,
                page: query.pageNumber,
            };

            filters.equal('id_cuotitas_request_type', REQUEST_TYPES.person);
            filters.equal('id_cuotitas_request_status', tab.id);

            if (date) {
                const startAt = dateFns.parse(dateFns.format(date, 'y-MM-dd 00:00:00'), 'y-MM-dd HH:mm:ss');
                const startTo = dateFns.parse(dateFns.format(date - 1, 'y-MM-dd 00:00:00'), 'y-MM-dd HH:mm:ss');

                filters.between(
                    'created_at',
                    dateFns.format(startTo, 'y-MM-dd 00:00:00'),
                    dateFns.format(startAt, 'y-MM-dd 23:59:59')
                );
            }

            if (search.length > 2 && validator.isInteger(search)) {
                filters.like('person.documents.document', `${search}*`);
            }

            if (search.length > 2 && !validator.isInteger(search)) {
                filters.like('person.attributes.description', `${search}*`);
            }

            options.filters = filters.build();

            const requests = await Signs.getRequests(options);

            const rows = [];

            for (const request of requests) {
                if (request.id_cuotitas_request_status > 4) {
                    continue;
                }
                const row = {};

                const firstName = request.person?.attributes?.find(attribute => attribute.description === 'first_name')?.value;
                const lastName = request.person?.attributes?.find(attribute => attribute.description === 'last_name')?.value;

                row.id = request.id;
                row.name = (firstName && lastName && `${firstName} ${lastName}`) || 'S/D';
                row.dni = request.person?.documents?.[0]?.description || 'S/D';
                row.created_at = dateFns.format(new Date(request.created_at), 'dd/MM/yyyy');
                row.status = singsStatuses[request.id_cuotitas_request_status];
                row.idPerson = request?.person?.id;

                rows.push(row);
            }

            setSignList(rows);
        }
        catch (error) {
            console.error(error);
            Alert.error('Se produjo un error interno, te pedimos disculpas. Por favor, intentalo de nuevo más tarde.', 5000);
        }
        finally {
            setLoading(false);
        }
    };

    const signCreationDefaults = {
        name: '',
        lastName: '',
        gender: '',
        dni: '',
        files: [],
    };

    const signCreationForm = [
        { name: 'name', label: 'Nombre*', type: 'text' },
        { name: 'lastName', label: 'Apellido*', type: 'text' },
        { name: 'gender', label: 'Género*', type: 'radio', options: [{ value: 'M', label: 'Masculino' }, { value: 'F', label: 'Femenino' }] },
        { name: 'dni', label: 'DNI*', type: 'text' },
        { name: 'files', label: 'Cargar Archivos*', type: 'file' },
    ];

    function signCreationValidate (person) {
        const errors = {};

        if (!parseInt(person.dni)) errors.dni = 'Por favor, ingrese un documento valido';

        if (!person.name.trim()) errors.name = 'Este campo es obligatorio';
        if (!person.lastName.trim()) errors.lastName = 'Este campo es obligatorio';
        if (!person.gender.trim()) errors.gender = 'Este campo es obligatorio';
        if (!person.dni.trim()) errors.dni = 'Este campo es obligatorio';
        if (person.files.length === 0) errors.files = 'Este campo es obligatorio';

        return errors;
    }

    async function signCreationSubmit (person) {
        try {
            const data = {
                person: {
                    attributes: [
                        { description: 'first_name',  value: person.name },
                        { description: 'last_name',  value: person.lastName },
                        { description: 'gender',  value: person.gender },

                    ],
                    documents: [
                        { idType: '1', document: person.dni }
                    ],
                    idType: 1,
                },
                files: []
            };

            for (const [index, file] of person.files.entries()) {
                const fileUrl = await cuotitasStore.uploadS3({
                    fileUri: file.blobFile,
                    filename: `${person.dni}-${index}-${Date.now()}-${(new ShortUniqueId({ length: 6 }))()}-${file.name}`,
                    dirname: 'file'
                });
                data.files.push(fileUrl);
            }

            return Signs.createUser(data)
                .then(response => {
                    Alert.success('El usuario se creo correctamente.', 5000);
                    setSignCreateDialog(false);
                    person.name = '';
                    person.lastName = '';
                    person.gender = '';
                    person.dni = '';
                    person.files = [];
                    filter();
                })
                .catch(e => {
                    console.error(e);
                    Alert.error('Se produjo un error interno, te pedimos disculpas. Por favor, intentalo de nuevo más tarde.', 5000);
                });
        }
        catch (error) {
            console.error(error);
            Alert.error('Se produjo un error interno, te pedimos disculpas. Por favor, intentalo de nuevo más tarde.', 5000);
        }
    }

    useEffect(() => {
        filter();
    }, [tab, query, date]);

    useEffect(() => {
        if (search === '') {
            filter();
        }
    }, [search]);

    useEffect(() => {
        setQuery({ ...query, pageNumber: 1 });
    }, [tab]);

    return (
        <main className='page'>
            <h1 className='page-header'>
                Firmas Cuotitas
            </h1>
            <div className="page-filters">
                <Tabs
                    className="page-filters-tabs"
                    items={tabs}
                    selected={tab}
                    onSelect={setTab}
                />
                <div className="page-filters-toolbar">
                    <Form id="form-toolbar" className="page-filters-form" onSubmit={filter}>
                        <FormControl
                            placeholder="Buscar por nombre o DNI"
                            appearance='subtle'
                            style={{ width: 300 }}
                            value={search}
                            onChange={setSearch}
                        />
                        <DatePicker
                            oneTap
                            style={{ width: 150 }}
                            size='md'
                            placeholder='Fecha de Alta'
                            renderValue={value => `${dateFns.format(value, 'dd/MM/y')}`}
                            onChange={setDate}
                            onClean={() => setDate(null)}
                        />
                    </Form>
                    <div className="page-filters-actions">
                        <Button type="submit" form="form-toolbar" appearance='primary' loading={loading}>
                            Buscar
                        </Button>
                        <Button appearance='primary' onClick={signCreateDialogOpen} disabled={loading}>
                            Crear Operación
                        </Button>
                    </div>
                </div>
            </div>
            <div className="page-content">
                <Table
                    data={signList}
                    columns={columns}
                    sort={defaultSorted}
                    onChange={setQuery}
                    isLoading={loading}
                    pagination={{
                        sizePerPage: query.pageSize,
                        page: query.pageNumber,
                    }}
                />
            </div>
            <DialogForm
                title="Nueva Operación de Firma"
                schema={signCreationForm}
                defaults={signCreationDefaults}
                show={signCreateDialogShow}
                onValidate={signCreationValidate}
                onSubmit={signCreationSubmit}
                onCancel={signCreateDialogClose}
            />
            {signUpdateDialogShow && <SignUpdateDialog
                id= {signSelected}
                show={signUpdateDialogShow}
                onHide={signUpdateDialogClose}
            />}
        </main>
    );
}
